import React, { ErrorInfo, useCallback, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Component, ObjectManager, ObjectSymbols } from '../../../concepts/objects';
import { Monitor } from '../../../platform/Monitor';
import { useResolve } from '../../Container';
import { VisualConfiguration } from './VisualConfiguration';

const { Ticker } = ObjectSymbols;

export const ComponentMount = ({ object, visual }: { object: Component, visual?: any }) => {

    const [ready, setReady] = useState(false);
    const [ticker, setTicker] = useState(-1);

    const objects = useResolve(ObjectManager);
    useEffect(() => {
        objects.on(object.id, 'affected', ([x]) => setTicker(x[Ticker]));
        setReady(true);
    }, []);

    const onError = useCallback((error: Error, info: ErrorInfo) => {
        Monitor.error(`RenderError in ${object.type}`, error, info);
    }, [object.type]);

    if (!object.alive) return null;
    if (!ready) return null;
    const Visual = visual ?? VisualConfiguration[object.type];
    if (!Visual) return null;

    return <ErrorBoundary {...{ onError }} fallback={<div />} >
        <Visual key={object.id} object={object}>
            {object instanceof Component && (
                object.children.map((x: any) => <ComponentMount key={x.id} object={x} />)
            )}
        </Visual>
    </ErrorBoundary>;
};
